var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tagBlock"},_vm._l((_vm.tags),function(tag,index){return _c('p',{key:index,staticClass:"small tag"},[_vm._v(_vm._s(_vm.metadata.find(function (x) { return x.id === tag; }).name))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }